import { render, staticRenderFns } from "./StudyNewPageScreeningQuestions.vue?vue&type=template&id=648985af&scoped=true"
import script from "./StudyNewPageScreeningQuestions.vue?vue&type=script&lang=js"
export * from "./StudyNewPageScreeningQuestions.vue?vue&type=script&lang=js"
import style0 from "./StudyNewPageScreeningQuestions.vue?vue&type=style&index=0&id=648985af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648985af",
  null
  
)

export default component.exports